import { takeLatest, call } from 'redux-saga/effects'
import * as fromActions from '../../actions/general.action'
import addDefaultProfiles from 'api/general/addDefaultProfiles'

async function addGeneralDefaultProfiles(profilesIds: number[]) {
  return await addDefaultProfiles(profilesIds)
}

function* addDefaultProfilesEffectSaga(action: any) {
  try {
    const profiles = action.payload
    yield call(addGeneralDefaultProfiles, profiles)
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* addDefaultProfilesWatcherSaga() {
  yield takeLatest(fromActions.GENERAL_LMS_PROFILES_DEFAULT_UPDATE, addDefaultProfilesEffectSaga)
}
